// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1vYNT","upload":"Small_upload__3Mxdm","imageWrap":"Small_imageWrap__2DteW","removeBtn":"Small_removeBtn__13KyH"};